import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from '../../utils/QueryKeys';
import { Package } from '../../models';

export function useHolidayPackage({ schoolId }) {
  return useQuery([QUERY_KEYS.package, QUERY_KEYS.holiday, schoolId], () => (
    Package
      .where({ hasPricesForSchool: schoolId, category: 'gift' })
      .first()
      .then((res) => res.data)
  ));
}
